import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemix: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRemix"><Path d="M21 20H6.41406L7.70703 21.293L6.29297 22.707L2.58594 19L6.29297 15.293L7.70703 16.707L6.41406 18H19V11H21V20Z" fill="currentColor"/><Path d="M13 11H16V13H13V16H11V13H8V11H11V8H13V11Z" fill="currentColor"/><Path d="M21.4141 5L17.707 8.70703L16.293 7.29297L17.5859 6H5V13H3V4H17.5859L16.293 2.70703L17.707 1.29297L21.4141 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemix;
